import manifest from "@app-theme";

/**
 * 빌드된 테마 매니페스트 — vite alias(@app-theme)가 VITE_APP_THEME=<name>으로
 * src/themes/<name>/manifest.ts를 직결한다(미설정 시 fantasy). tsc/vitest는 fantasy 고정.
 * 앱 코드는 이 THEME만 import — 매니페스트 모듈을 직접 import하지 않는다(테마 고정 방지).
 */
export const THEME = manifest;
